/** Public demo CDN (legacy Supabase storage). Used for marketing avatars/media. */
export const DEMO_CDN_BASE =
  (import.meta.env.VITE_DEMO_CDN_URL as string | undefined)?.replace(/\/$/, '') ||
  (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://hdtgqbtxmtvridkxsjcd.supabase.co';

export const DEMO_AVATARS = `${DEMO_CDN_BASE}/storage/v1/object/public/demo/avatars`;
export const DEMO_WEBSITE = `${DEMO_CDN_BASE}/storage/v1/object/public/demo/Website`;

export const demoAvatar = (file: string) => `${DEMO_AVATARS}/${file}`;
export const demoWebsite = (file: string) => `${DEMO_WEBSITE}/${file}`;
